"use client";

import { useEffect, useRef } from "react";
import {
	pushVwoExperimentEvent,
	type VWOExperimentDecision,
} from "@/lib/utils/dataLayerHelpers";

interface VWOExperimentPushProps {
	decisions: VWOExperimentDecision[];
}

/**
 * Client-only component that fires one `vwo-data-push-ga4` dataLayer event
 * per VWO experiment decision on initial mount. The push is guarded by a ref
 * so it fires exactly once per page load, even under React strict-mode double
 * invocation.
 *
 * Renders nothing — purely a side-effect component.
 */
export default function VWOExperimentPush({
	decisions,
}: VWOExperimentPushProps) {
	const pushedRef = useRef(false);

	useEffect(() => {
		if (pushedRef.current || !decisions.length) return;
		pushedRef.current = true;

		for (const decision of decisions) {
			pushVwoExperimentEvent(decision);
		}
	}, []); // oxlint-disable-line react-hooks/exhaustive-deps

	return null;
}
